import { Inject, Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { AuthHttp, JwtHelper } from 'angular2-jwt';
import { EnvironmentsService } from './enviornment.service';
import { AuthProviderService } from './auth.provider.service';
import { DOCUMENT } from '@angular/common';
import { AuthService } from 'app/auth/authservice.service';
import { BehaviorSubject} from 'rxjs';

@Injectable()
export class AuthenticationService {

  private SESSION_KEY = 'esp-api-client-session';
  subject = new Subject<any>();
  public jwtHelper: JwtHelper;
  private currentSession: BehaviorSubject<any>;

  constructor(private http: Http, private authhttp: AuthHttp, private router: Router, private envService: EnvironmentsService, private authProvider: AuthProviderService, @Inject(DOCUMENT) private document: Document, private authService: AuthService) {
    this.jwtHelper = new JwtHelper();
    let session = null;
    try {
      session = JSON.parse(localStorage.getItem(this.SESSION_KEY));
    } catch (e) {
    }
    this.currentSession = new BehaviorSubject(session);
  }

  login(username: string, password: string, loginType: string) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    
    
    return this.authhttp.get(this.envService.config.cspUrl + "/am/api/auth/token-public-key?format=jwks")
      .map((response: Response) => {
        let data = response.json();
        if (data && data.value) {
          localStorage.setItem("token", data.value);
	  localStorage.setItem('currentUser', username);
        
          this.subject.next({ isUserLoggedIn: true, name: username });
        }
        return data;
      });
  }

  logout() {
    const redirectUri = window.location.origin + this.envService.config.redirectUri;
    window.location.href = `${this.authProvider.getApiLogoutUrl()}?client_id=${this.envService.config.clientId}&redirect_uri=${redirectUri}&state=${this.envService.config.state}`;
  }

  getLoginUrl() {
    const redirectUri = window.location.origin + this.envService.config.redirectUri;
    if (this.envService.config.production) {
      return  `${this.authProvider.getApiUrl()}/authorize?response_type=code&client_id=${this.envService.config.clientId}&state=${this.envService.config.state}&redirect_uri=${redirectUri}`;
    } else {
       return `${this.authProvider.getApiUrl()}/authorize?response_type=code&client_id=${this.envService.config.clientId}&state=${this.envService.config.state}&redirect_uri=${redirectUri}&bypass_uri_check=true`;
    }
  }

  getCSPLoginUrl() {
    const redirectUri = window.location.origin + this.envService.config.redirectUri;
      return `${this.envService.config.cspUrl}/discovery?idp_id=omnissa.com&response_type=code&client_id=${this.envService.config.clientCSPId}&redirect_uri=${this.envService.config.redirectCSPUri}&state=${this.envService.config.state}&orgLink=${this.envService.config.orgLink}&code_challenge=${this.envService.config.codeChallenge}&code_challenge_method=S256`;
  }

  saveCurrentSession(session){
    session.user = this.jwtHelper.decodeToken(session.access_token);
    localStorage.setItem(this.SESSION_KEY,JSON.stringify(session));
    this.currentSession.next(session);
  }
  redirectToLogin(){
    window.location.href = this.getCSPLoginUrl();
  }


  verifyLogin() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      this.subject.next({ isUserLoggedIn: true, name: currentUser.email });
    } else {
      this.subject.next({ isUserLoggedIn: false, name: "" });
    }
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  getCurrentSession(): BehaviorSubject<any> {
    return this.currentSession;
  }

  getUser(): any {
    const session = this.currentSession.getValue();
    return session ? session.user : null;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts